// removed by extract-text-webpack-plugin
module.exports = {"container":"_1Z51Oa3VB78difH2RATI4b","email":"_3PTWuoRaeWx0k-te-L07q3","title":"_1aUyiX8dRwo1_ixOAe00r2","header":"Tdk3H6s446bEFF1Cw1Ikp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/StatisticsSelectedRecipientInfo/StatisticsSelectedRecipientInfo.scss
// module id = 1333
// module chunks = 1